import React from 'react';
import { ActionPlanContextType } from '../../../../services/types/ActionPlan';

const Context = React.createContext<ActionPlanContextType>({
  operationActionPlans: [],
  supervisionReportLanguage: null,
  canCreate: false,
  aplicablePolicyOptions: [],
  indicators: [],
  grantedWrite: false,
  loading: false,
  blokedBySR: false,
  stepSR: '',
  reload: () => {},
});

export default Context;
